export default __webpack_public_path__ + "static/media/officeChampion.afa0abc1.png";